<template>
  <div class="wrapper">
    <div class="temoignages" v-for="(temoignage, i) in fields.temoignages" :key="i">
          <prismic-rich-text :field="temoignage.temoignage" class="temoignages" />
    </div>
  </div>
</template>

<script>
import Slideshow from '@/components/Slideshow.vue';

export default {
  name: 'Temoignages',
  components: {
    Slideshow
  },
  data () {
    return {
      fields: {
        temoignages: [],
      }
    }
  },
  methods: {
    getContent (uid) {
      this.$prismic.client.getSingle('temoignages')
          .then((document) => {
            this.fields.temoignages = document.data.temoignages;
            console.log(this.fields.temoignages)
          })
    }
  },
  created () {
    this.getContent();
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent()
    next()
  }
}
</script>

<style>
.wrapper {
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1em;
  padding: 40px 10px;
}

.temoignages {
  margin-bottom: 4em;
}
</style>